@if (settings$ | async; as settings) {
	<header>
		<stages-button
			[buttonType]="'button'"
			[title]="'back'"
			[iconClasses]="'ico-chevron-left-small'"
			[buttonClasses]="'menu-button'"
			[showIconOnly]="true"
			(clicked)="closeButtonPressed.emit()"
		>
		</stages-button>
		<h3 (click)="closeButtonPressed.emit()" translate="back" class="pointer"></h3>
	</header>
	<div class="tab-container">
		<stages-tabs [disbaleScrolling]="true">
			@if (settings.historyEnabled) {
				<stages-tab-no-route
					[active]="activeContainer === ChatbotChildContainer.HISTORY"
					(activate)="openChildContainer(ChatbotChildContainer.HISTORY, ChatbotChildContainer.SETTINGS)"
				>
					<h5 translate="chatbot.history"></h5>
				</stages-tab-no-route>
			}
			<stages-tab-no-route
				[active]="activeContainer === ChatbotChildContainer.SETTINGS"
				(activate)="openChildContainer(ChatbotChildContainer.SETTINGS, ChatbotChildContainer.HISTORY)"
			>
				<h5 translate="settings"></h5>
			</stages-tab-no-route>
			<div class="spacer"></div>
			<stages-menu
				[ngClass]="{ 'hidden-menu': settingsOpen }"
				class="action"
				menuId="muChatHistory"
				iconClasses="ico ico-more-vertical"
				openTo="left"
				[items]="historyMenuItems"
				[noCollapse]="true"
			>
			</stages-menu>
		</stages-tabs>
	</div>
	<div class="chatbot-panel">
		<div class="view-container-parent">
			@if (settings.historyEnabled) {
				<div class="view-container-child" id="history">
					<stages-chatbot-history (chatSelected)="reloadChatbot()" (chatsDeleted)="onChatsDeleted($event)">
					</stages-chatbot-history>
				</div>
			}
			@if (settingsOpen) {
				<div class="view-container-child" id="settings">
					<stages-chatbot-settings [settings$]="settings$"> </stages-chatbot-settings>
				</div>
			}
		</div>
	</div>
}
